import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Simulator } from './components/Simulator';
import { Gallery } from './components/Gallery';
import { TrustFactors } from './components/TrustFactors';
import { FloatingCTA } from './components/FloatingCTA';
import { OnlineCounter } from './components/OnlineCounter';
import { FAQ } from './components/FAQ';
import { Reviews } from './components/Reviews';
import { MarketTicker } from './components/MarketTicker';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-blue-600/30 selection:text-blue-900 pb-24 md:pb-0" data-id="element-0">
      <MarketTicker data-id="element-1" />
      <OnlineCounter data-id="element-2" />
      <Navbar data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <Simulator data-id="element-7" />
        <Gallery data-id="element-8" />
        <FAQ data-id="element-9" />
        <TrustFactors data-id="element-10" />
        <Reviews data-id="element-11" />
      </main>
      <FloatingCTA data-id="element-12" />
    </div>;
}